module.exports = __webpack_public_path__ + "img/img001.910ebd4c.png";